<div class="dash-header">
  <div class="dash-header-left">
    <h1 class="dash-title">Consolidated Summary Report</h1>
    <span class="dash-date-display">{{period}}</span>
  </div>
  <div class="dash-header-right">
    <label class="date-label">Month</label>
    <input type="month" class="date-input" [min]="startPeriod" [(ngModel)]="period" (change)="success = ''; load()" [disabled]="saving" />
  </div>
</div>

<div class="company-scope" *ngIf="!is_loading && companies.length && !shareholder">
  <span class="scope-label">{{companies.length}} companies combined · Converted to MYR</span>
</div>

<div class="loading-bar" *ngIf="is_loading"><div class="loading-bar-inner"></div></div>
<div class="alert alert-danger" *ngIf="error">{{error}}</div>
<div class="alert alert-success" *ngIf="success">{{success}}</div>
<div class="alert alert-info" *ngIf="!is_loading && !error && companies.length === 0">No assigned companies are available.</div>

<div class="dash-card" *ngFor="let summary of summaries">
  <div class="dash-card-header"><h2>{{summary.month}}</h2></div>
  <div class="dash-table-wrap">
    <table class="dash-table">
      <thead>
        <tr>
          <th class="col-name">Company</th>
          <th class="col-num" *ngFor="let column of columns">{{column.title}}</th>
          <th class="col-name">Manager Checked</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!summary.companies.length">
          <td class="state-cell" [attr.colspan]="columns.length + 2">No Data Available</td>
        </tr>
        <tr *ngFor="let company of summary.companies">
          <td class="col-name company-name">{{company.company_name}}</td>
          <td class="col-num" *ngFor="let column of columns" [class.text-danger]="(column.key === 'capital' ? capitalAmount(company) : company[column.key]) < 0">
            {{(column.key === 'capital' ? capitalAmount(company) : (company[column.key] ?? 0)) | number: '1.2-2'}}
          </td>
          <td class="col-name text-center">{{company.summary_checked == 1 ? 'Yes' : '—'}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="p-3" *ngIf="summary.capital_edit as edit">
    <label [attr.for]="'capital-' + summary.month">Consolidated Capital (MYR)</label>
    <div class="d-flex align-items-center gap-2">
      <input *ngIf="edit.can_edit_capital" type="number" step="0.01" class="form-control capital-input"
        [id]="'capital-' + summary.month" [attr.aria-label]="'Consolidated capital ' + summary.month"
        [(ngModel)]="edit.draft_capital" [disabled]="saving || is_loading" />
      <button *ngIf="edit.can_edit_capital" type="button" class="btn btn-primary btn-sm"
        [disabled]="saving || is_loading || edit.draft_capital === edit.capital"
        (click)="saveCapital(edit)">Save</button>
      <span *ngIf="!edit.can_edit_capital" class="text-muted">View only</span>
    </div>
    <small class="text-muted">Adjusts this month's consolidated Capital only. Company capitals stay unchanged.</small>
  </div>
  <div class="p-3" *ngIf="summary.cash_edit as edit">
    <label [attr.for]="'cash-' + summary.month">Consolidated Cash B/F (MYR)</label>
    <div class="d-flex align-items-center gap-2">
      <input *ngIf="edit.can_edit_cash" type="number" step="0.01" class="form-control capital-input"
        [id]="'cash-' + summary.month" [attr.aria-label]="'Consolidated cash B/F ' + summary.month"
        [(ngModel)]="edit.draft_cash_bf" [disabled]="saving || is_loading" />
      <button *ngIf="edit.can_edit_cash" type="button" class="btn btn-primary btn-sm"
        [disabled]="saving || is_loading || edit.draft_cash_bf === edit.cash_bf"
        (click)="saveCash(edit)">Save</button>
      <span *ngIf="!edit.can_edit_cash" class="text-muted">View only</span>
    </div>
    <small class="text-muted">Sets this month's consolidated opening cash. Closing Cash is recalculated and carried forward. Company cash balances stay unchanged.</small>
  </div>
</div>

<ng-container *ngIf="!is_loading && !error"><app-company-share-report *ngFor="let summary of summaries" [report]="summary.share_split"></app-company-share-report></ng-container>
